import { useState, useRef } from "react";
import { Modal, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import birdseyBg from "./../../../../public/assets/images/birdsEyBg1.jpg";
import birdseyLogo from "./../../../../public/assets/images/birdsEy_logo.png";
import { useSelector } from "react-redux";
import { birdseyeSaveLead } from "@/api/PDP"
import { validateForm } from "@/utils/formValidator";
import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";

const BirdseyModal = ({ setShowBanner, showBanner, propertyId }) => {
  const leadFormDetails = [
    {
      name: 'firstName',
      type: "text",
      placeholder: "First Name",
      required: true,
      editLink: false,
      maxLength: 40,
      formValueLabel: "firstName",
    },
    {
      name: 'lastName',
      type: "text",
      placeholder: "Last Name",
      required: true,
      editLink: false,
      maxLength: 40,
      formValueLabel: "lastName",
    },
    {
      type: "companyName",
      placeholder: "Company Name",
      required: true,
      editLink: false,
      maxLength: 100,
      formValueLabel: "companyName",
      name: 'companyName',
    },
    {
      type: "email",
      placeholder: "Email",
      required: true,
      editLink: false,
      formValueLabel: "emailId",
      name: 'emailId',
    },
    {
      type: "tel",
      placeholder: "Phone",
      required: true,
      editLink: false,
      formValueLabel: "phoneNumber",
      maxLength: 10,
      name: "phoneNumber",
    },
  ];

  const loanFormDetails = [
    {
      type: "text",
      placeholder: "Requested Loan Amount",
      required: true,
      editLink: false,
      formValueLabel: "loanAmount",
      name: "loanAmount",
    },
    {
      type: "number",
      placeholder: "Net Worth",
      required: true,
      editLink: false,
      formValueLabel: "netWorth",
      name: "netWorth",
    },
    {
      type: "text",
      placeholder: "Chapter 7 or 13 in last 5 years",
      required: true,
      editLink: false,
      formValueLabel: "chapter7",
      name: "chapter7"
    },
  ];
  const { user } = useSelector((state) => state?.user);
  const [foreClosure, setForeClosure] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [loanFormErrors, setLoanFormErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  
  const [formData, setFormData] = useState({
    firstName: user.userFirstName || "",
    lastName: user.userLastName || "",
    companyName: "",
    emailId: user.userEmailId || "",
    phoneNumber: user.primaryPhone || "",
  });
  const [loanFormData, setLoanFormData] = useState({
    loanAmount: "",
    netWorth: "",
    chapter7: "",
  });

  let formRef = useRef();
  let loanFormRef = useRef();

  const validationRules = {
    firstName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    lastName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    companyName: (value) => {
      if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
    emailId: (value) => {
      if (!value) return "This field is required";
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return "Please enter a valid email address";
      }
      return "";
    },

    phoneNumber: (value) => {
      if (!value) return "This field is required";
      if (!/^\d{10}$/.test(value.replace(/\D/g, ""))) return "Please enter a valid phone number";
      return "";
    },
    loanAmount: (value) => {
      if (!value?.trim()) return "This field is required";
      // if (!/^\d{10}$/.test(value)) {
      //   return "Please enter valid amount";
      // }
      return "";
    },
    netWorth: (value) => {
      // if (!value?.trim()) return "This field is required";
      const allowedCharsRegex = /^[a-zA-Z0-9#(),.'\s]*$/;
      // if (!/^\d{10}$/.test(value)) {
      //   return "Please enter valid amount";
      // }
      return "";
    },
    chapter7: (value) => {
      const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
      if (value && !allowedCharsRegex.test(value)) {
        return "Characters allowed: a-z A-Z 0-9 and - . ' _";
      }
      return "";
    },
  };
  const onHide = () => {
    setFormErrors({});
    setLoanFormErrors({});
    setShowBanner(false);
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === "phone" || name === "phoneNumber") {
      // Remove all alphabet characters
      processedValue = value.replace(/[a-zA-Z]/g, "");
    }
    setFormData((prev) => ({
      ...prev,
      [name]: processedValue,
    }));
  };
  const handleLoanFormChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    if (name === "loanAmount" || name === "netWorth") {
      // Remove all alphabet characters
      processedValue = value.replace(/[a-zA-Z]/g, "");
    }
    setLoanFormData((prevData) => ({
      ...prevData,
      [name]: processedValue,
    }));
  };


  const validateForms = () => {
    const formErrors = validateForm(formData, Object.keys(formData));
    if (Object.keys(formErrors).length > 0) {
      setFormErrors(formErrors);
      return true;
    }

    const loanFormErrors = validateForm(loanFormData, Object.keys(loanFormData));
    if (Object.keys(loanFormErrors).length > 0) {

      const hasAnyErrors = Object.values(loanFormErrors).some(error => error !== '');
       setLoanFormErrors(loanFormErrors);
      if(hasAnyErrors){
          return true;
      }
    }

    return false


  }
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    let isError = validateForms();
    for (const [key, value] of Object.entries(formData)) {
      const validationError = validationRules[key](value);
      setFormErrors((prev) => ({
        ...prev,
        [key]: validationError,
      }));
    }
    for (const [key, value] of Object.entries(loanFormData)) {
      const validationError = validationRules[key](value);
      setLoanFormErrors((prev) => ({
        ...prev,
        [key]: validationError,
      }));
    }
    //loanFormDetails

    const allErrors = { ...formErrors, ...loanFormErrors };
    const hasAnyErrors = Object.values(allErrors).some(error => error !== '');
    if (!hasAnyErrors && !isError) {
      const payload = {
        firstName: formData.firstName || "",
        lastName: formData.lastName || "",
        email: formData.emailId || "",
        phone: formData.phoneNumber || "",
        requestedLoanAmount: loanFormData.loanAmount || "",
        netWorth: loanFormData.netWorth || "",
        chapterSevenOrThirteenInPast5Years: loanFormData.chapter7 || "",
        leadSource: "birdsey",
        propertyId: propertyId,
        companyName: formData.companyName,
        foreclosureInPastThreeYears: foreClosure
      };
      setIsSaving(true);
      const data = await birdseyeSaveLead(payload);
      if (data) {
         setIsSaving(false);
        setShowBanner(false);


        setFormData({
          firstName: user.userFirstName || "",
          lastName: user.userLastName || "",
          companyName: "",
          emailId: user.userEmailId || "",
          phoneNumber: user.primaryPhone || "",
        });
        setLoanFormData({
          loanAmount: "",
          netWorth: "",
          chapter7: "",
        });
      }
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (validationRules[name]) {
      const validationError = validationRules[name](value);
      setFormErrors((prev) => ({
        ...prev,
        [name]: validationError,
      }));
    }
  };
  const handleBlurLoanForm = (e) => {
    const { name, value } = e.target;
    if (validationRules[name]) {
      const validationError = validationRules[name](value);
      setLoanFormErrors((prev) => ({
        ...prev,
        [name]: validationError,
      }));
    }
  };
  const handleForclousreSelection = (e) => {
    setForeClosure(e.target.value)
  }

  const formatPhoneNumber = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "").slice(0, 10); // Only digits, max 10
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]})-${match[2]}-${match[3]}`;
    }
    return cleaned;
  };


  return (
    <Modal show={showBanner} onHide={onHide} closeButton size="xl">
      <Modal.Header closeButton className="birdsey-modal-header"></Modal.Header>
      <div className="pb0 pr0 pl0">
        <Row xs={12} md={12} className="m0">
          <Col xs={12} md={6} className="p30">
            <Row className="m0">
              <p className="birds-feader-text pb30">Fill out the form below and a Birdsey Capital Partners representative will reach out to you to review available financing options.</p>
              <h3 className="bird-info-text">CONTACT INFORMATION</h3>

              {leadFormDetails.slice(0, 2).map((item, index) => (
                <Col className="m0" key={`${index}-${item?.name}`}>
                  <Form.Group key={index} className="mb-3 ">
                    <Form.Control
                      className="birds-input-field"
                      type={item.type}
                      name={item.formValueLabel}
                      placeholder={item.placeholder}
                      value={formData[item.formValueLabel] || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required={item.required}
                      isInvalid={!!formErrors[item.name]}
                      maxLength={item?.maxLength ? item?.maxLength : ""}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formErrors[item.name]}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              ))}
              {leadFormDetails.slice(2, leadFormDetails?.length).map((item, index) => (
                <Form.Group key={index} className="mb-3 ">
                  <Form.Control
                    className="birds-input-field"
                    type={item.type}
                    maxLength={item?.maxLength ? item?.maxLength : ""}

                    name={item.formValueLabel}
                    placeholder={item.placeholder}
                    // value={
                    //   item.name === "phoneNumber"
                    //     ? formatPhoneNumber(
                    //       formData[item.formValueLabel] || ""
                    //     )
                    //     : formData[item.formValueLabel]|| ""
                    // }
                    value={formData[item.formValueLabel] || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={item.required}
                    isInvalid={!!formErrors[item.name]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formErrors[item.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}
              <h3 className="bird-info-text">LOAN INFORMATION</h3>
              {loanFormDetails.map((item, index) => (
                <Form.Group key={index} className="mb-3">
                  <Form.Control className="birds-input-field"
                    type={item.type}
                    name={item.formValueLabel}
                    placeholder={item.placeholder}
                    value={loanFormData[item.formValueLabel] || ""}
                    onChange={handleLoanFormChange} // Use the updated handleChange function
                    required={item.required}
                    onBlur={handleBlurLoanForm}
                    isInvalid={!!loanFormErrors[item.name]}
                  />
                  <Form.Control.Feedback type="invalid">
                    {loanFormErrors[item.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}
              <Row className="pt5">
                <Col xs={8} md={8} className="">
                  <div >
                    <p className="birds-eye-subtitle1">Previous Foreclosures in Last 3 Years:</p>
                  </div>
                  
                </Col>
                 <Col md={2}  xs={2}>
                    <div className="hubzu-backup-bid-option">
                      <Form.Check
                        type="radio"
                        id="yesRadio"
                        name="backupBid"
                        className="birds-eye-subtitle1 radio-style"
                        onChange={handleForclousreSelection} // Using existing handler
                        value="Y" // Same value as before
                        label={"Yes"}
                      />
                    </div>
                  </Col>
                  <Col md={1}  xs={1}>
                    <div className="hubzu-backup-bid-option">
                      <Form.Check
                        type="radio"
                        id="noRadio"
                        name="backupBid"
                        className="birds-eye-subtitle1 radio-style"
                        onChange={handleForclousreSelection} // Using existing handler
                        value="N" // Same value as before
                        label={"No"}
                      />
                    </div>
                  </Col>
                <Row>
                 
                </Row>
              </Row>
            </Row>
            <Row className="m0 pt5 pl10 pr15">
              <button type="submit" id="birdeySubmit" onClick={handleSubmit} className="btn btn-primary">
                {isSaving ? (
                  <LoadingText text="Submiting..." />
                ) : (
                  <LoadedText text="Submit" />
                )}

              </button>
              <p className="birds-footer p0 m-0 mt-3">By pressing submit and providing my contact information, I agree to be
                contacted according to
                these
                <a className="link" style={{ color: '#118BF4' }} href="/about/terms" target="_blank" rel="Tnc"> Terms &amp; Conditions</a> and <a  className="link" style={{ color: '#118BF4' }} href="https://www.altisource.com/Privacy-Policy" target="_blank" rel="noopener">Privacy
                  Policy</a>.
                This consent includes receiving marketing or advertising calls, texts, emails, artificial voice
                or prerecorded messages, via autodialed or other automated means, from Altisource, Altisource
                Online Auction, Inc., Birdsey Capital Partners and its affiliates.
                I understand that this consent is not a condition to receiving any services.
              </p>
            </Row>
          </Col>
          <Col xs={12} md={6} className="birdsEyeBg"
            style={{
              backgroundImage: `url(${birdseyBg})`, backgroundSize: "cover",
              backgroundPosition: "center",
            }}>
            <div className="p40" >
              <div class="birds-img-cont">
                <img src={birdseyLogo} alt="Birdsey Capital Partners" />
              </div>
              <div className="birds-banner-txt">Unlock the full potential of your commercial real estate investments
                with Birdsey Capital Partners.
              </div>
              <p className="birds-para-txt">For over 20 years, Birdsey Capital Partners has partnered with hundreds of
                top-tier lenders
                nationwide, offering a comprehensive suite of debt products tailored to meet the needs of
                commercial
                real estate owners and investors.</p>
              <ul class="birds-ul-txt">
                <li>{" \u2022   "}  Multifamily (5+ units)</li>
                <li> {" \u2022   "} Manufactured Home Communities</li>
                <li> {" \u2022   "} SFR Rental Portfolios</li>
                <li> {" \u2022   "} Retail</li>
                <li> {" \u2022   "} Office</li>
                <li> {" \u2022   "} Industrial (Building/Condo)</li>
                <li> {" \u2022   "} Self Storage</li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default BirdseyModal;
